import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { makeRestRequest } from 'src/modules/api/sagas/utils/makeRestRequest';
import { call } from 'typed-redux-saga';

export function* resetFeedbackRequestTrigger(): SagaIterator<void> {
  try {
    yield* call(
      makeRestRequest,
      'DELETE',
      '/feedback/request',
    );
  } catch (error) {
    throw new RuntimeError('Could not reset feedback request trigger', {}, NativeError.wrap(error));
  }
}
